<nz-table
  #endpointsTable
  [nzData]="endpoints"
  [nzShowPagination]="false"
  nzSize="small"
  class="border border-secondary-border rounded overflow-hidden mt-2"
>
  <thead>
    <tr class="bg-table-header-background">
      <th class="!bg-transparent text-primary-text font-semibold w-24">
        {{ config.texts.epMethod }}
      </th>
      <th class="!bg-transparent text-primary-text font-semibold">
        {{ config.texts.epName }}
      </th>
      <th class="!bg-transparent text-primary-text font-semibold">
        {{ config.texts.epPath }}
      </th>
      <th class="!bg-transparent text-primary-text font-semibold">
        {{ config.texts.epDesc }}
      </th>
      <th
        class="!bg-transparent text-primary-text font-semibold text-center w-24"
      >
        {{ config.texts.epMocked }}
      </th>
    </tr>
  </thead>
  <tbody>
    @for (ep of endpointsTable.data; track ep.id) {
      <tr class="hover:bg-hover-table transition-colors">
        <td class="!bg-transparent border-t border-secondary-border">
          <span
            class="px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider border {{
              getMethodColor(ep.method)
            }}"
          >
            {{ ep.method }}
          </span>
        </td>
        <td
          class="!bg-transparent border-t border-secondary-border font-medium text-primary-text text-sm"
        >
          {{ ep.name }}
        </td>
        <td class="!bg-transparent border-t border-secondary-border">
          <span
            class="font-mono text-sm text-primary-text bg-alt-bold-background px-2 py-0.5 rounded border border-primary-border"
          >
            {{ getFullPath(ep.path) }}
          </span>
        </td>
        <td
          class="!bg-transparent border-t border-secondary-border text-sm text-secondary-text"
        >
          {{ ep.description }}
        </td>
        <td
          class="!bg-transparent border-t border-secondary-border text-center"
        >
          <i
            class="fas text-lg"
            [ngClass]="
              ep.isMocked
                ? 'fa-check text-success'
                : 'fa-times text-secondary-text opacity-50'
            "
          ></i>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
